<template>
	<div>
    <!-- Main Wrapper -->
		<div class="main-wrapper">
		
			<!-- Header -->
                <layout-header />
			<!-- /Header -->
			
			<!-- Breadcrumb -->
			<div class="breadcrumb-bar">
				<div class="container-fluid">
					<div class="row align-items-center">
						<div class="col-md-12 col-12">
							<nav aria-label="breadcrumb" class="page-breadcrumb">
								<ol class="breadcrumb">
									<li class="breadcrumb-item"><router-link to="/index">Home</router-link></li>
									<li class="breadcrumb-item active" aria-current="page">Dashboard</li>
								</ol>
							</nav>
							<h2 class="breadcrumb-title">Dashboard</h2>
						</div>
					</div>
				</div>
			</div>
			<!-- /Breadcrumb -->
			
			<!-- Page Content -->
			<div class="content">
				<div class="custom-container">

					<div class="row">
						
						<!-- Profile Sidebar -->
						<div class="col-md-5 col-lg-4 col-xl-3 theiaStickySidebar">
							<Sidebar />
						</div>
						<!-- / Profile Sidebar -->
						
						<div class="col-md-7 col-lg-8 col-xl-9">
							<div class="card">
								<div class="card-body pt-0">
								
									<!-- Tab Menu -->
									<nav class="user-tabs mb-4">
										<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
											<li class="nav-item">
												<a class="nav-link active" href="#pat_medical_records" data-toggle="tab"><span class="med-records">Manajemen Paket</span></a>
											</li>
											<!-- <li class="nav-item">
												<a class="nav-link" href="#pat_appointments" data-toggle="tab">Semua Kelas</a>
											</li> 
											<li class="nav-item">
												<a class="nav-link" href="#pat_billing" data-toggle="tab">Kalender</a>
											</li> -->
										</ul>
									</nav>
									<!-- /Tab Menu -->
									
									<!-- Tab Content -->
									<div class="tab-content pt-0">
											 
										<!-- Course Records Tab -->
										<div id="pat_medical_records" class="tab-pane fade show active">
											<div class="card card-table mb-0">
												<div class="card-body">
													
                                                    <div class="col-auto text-right float-right ml-auto">
                                                        <a href="#" class="btn btn-primary btn-sm" @click.prevent="getAdd()">Tambah Paket</a>
                                                    </div>
													<div class="table-responsive">
														<table id="tbl" class="table table-hover table-center mb-0">
															<thead>
																<tr>
																	<th>ID</th>
																	<th>Nama Paket</th>
																	<th>Tipe</th>
																	<th>Harga Awal</th>
																	<th>Diskon</th>
																	<th>Harga Aktif</th>
																	<th>Masa Berlaku</th>
																	<th>Jumlah Tryout</th>
																	<th>Status</th>
																	<th>Aksi</th>
																</tr>     
															</thead>
															<tbody>
																<tr v-for="(ref, index) in lstpaket" :key="ref.id_paket">
                                                                    <td>{{ index + 1 }}</td>
                                                                    <td>{{ ref.nama_paket }}</td>
                                                                    <td class="text-center">
    																	<span v-if="ref.tipe_paket == '2'">BIMBEL</span>
																		<span v-else>MANDIRI</span>
																	</td>
                                                                    <td class="text-right">{{ ref.harga_awal }}</td>
                                                                    <td class="text-center">{{ ref.diskon }}%</td>
                                                                    <td class="text-right">{{ ref.harga_aktif }}</td>
                                                                    <td class="text-center">{{ ref.masa_berlaku }} bulan</td>
                                                                    <td class="text-center">{{ ref.jml_to }} TO</td>
                                                                    <td class="text-center">
    																	<span v-if="ref.fg_publish = '2'">PUBLISH</span>
																		<span v-else>DRAFT</span>
																	</td>																	
                                                                    <td>
                                                                        <v-btn class="btn btn-sm bg-success-light" depressed small @click="getEdit(ref)">
                                                                            <i class="fas fa-edit"></i> Edit
                                                                        </v-btn>
                                                                        <v-btn color="btn btn-sm bg-danger-light" depressed small @click="getDelete(ref)">
                                                                            <i class="fas fa-times"></i> Delete
                                                                        </v-btn>
                                                                    </td>
                                                                </tr>
																
															</tbody>  	
														</table>
													</div>
												</div>
											</div>
										</div>
										<!-- /Course Records Tab -->
										
										<!-- Appointment Tab -->
										<div id="pat_appointments" class="tab-pane fade">
											<div class="card">
												<div class="card-body">
                                                    
                                                    <!-- <div class="row row-grid">
                                                        <div class="col-md-6 col-lg-4" v-for="item in instructors" :key="item.id">
                                                            <div class="card widget-profile pat-widget-profile">
                                                                <div class="card-body">
                                                                    <div class="pro-widget-content">
                                                                        <div class="profile-info-widget">
                                                                            <router-link to="/instructor/profile" class="booking-doc-img">
                                                                                <img :src="loadImg(item.image)" alt="User Image">
                                                                            </router-link>
                                                                            <div class="profile-det-info">
                                                                                <h3><router-link to="/instructor/profile">{{item.name}}</router-link></h3>
                                                                                
                                                                                <div class="receiver-details">
                                                                                    <h5><b>Instructor ID :</b> {{item.instructor_id}}</h5>
                                                                                    <h5 class="mb-0"><i class="fas fa-map-marker-alt"></i>{{item.location}}</h5>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <div class="receiver-info">
                                                                        <ul>
                                                                            <li>Phone <span>{{item.phone}}</span></li>
                                                                            <li>Age <span>{{item.age}}, {{item.gender}}</span></li>
                                                                            <li>Subject <span>{{item.subject}}</span></li>
                                                                        </ul>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div> -->

												</div>
											</div>
										</div>
										<!-- /Appointment Tab -->
									
										<!-- Billing Tab -->
										<div id="pat_billing" class="tab-pane fade">
											<div class="card card-table mb-0">
												<div class="card-body">
													<div class="table-responsive">
														<table class="table table-hover table-center mb-0">
															<thead>
																<tr>
																	<th>Invoice No</th>
																	<th>School</th>
																	<th>Amount</th>
																	<th>Paid On</th>
																	<th></th>
																</tr>
															</thead>
															<tbody>
																
															</tbody>
														</table>
													</div>
												</div>
											</div>
										</div>
										<!-- /Billing Tab -->
										  
									</div>
									<!-- Tab Content -->
									
								</div>
							</div>
						</div>
					</div>

				</div>

			</div>		
			<!-- /Page Content -->
   
			<!-- Footer -->
                <layout-footer />
			<!-- /Footer -->
		</div>
			
		<div id="addMdl" class="modal custom-modal fade" role="dialog">
			<div class="modal-dialog modal-dialog-centered modal-xl" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h4 class="modal-title">Tambah Paket</h4>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">

						<!-- <div class="card card-table mb-0">
							<div class="card-body"> -->
								<!-- Tab Menu -->
								<nav class="user-tabs mb-4">
									<ul class="nav nav-tabs nav-tabs-bottom nav-justified">
										<li class="nav-item">
											<a class="nav-link active" href="#informasipaket" data-toggle="tab"><span class="med-records">Info Paket</span></a>
										</li>
										<li class="nav-item" v-if="paket.id_paket">
											<a class="nav-link" href="#attachtryout" data-toggle="tab">Attach Tryout</a>
										</li> 
										<li class="nav-item" v-if="paket.id_paket">
											<a class="nav-link" href="#attachkategori" data-toggle="tab">Attach Kategori</a>
										</li>
									</ul>
								</nav>
								<!-- /Tab Menu -->
								
								<!-- Tab Content -->
								<div class="tab-content pt-0">
											
									<!-- Course Records Tab -->
									<div id="informasipaket" class="tab-pane fade show active">
										<!-- <div class="card card-table">											 -->
											<!-- <div class="card-body">
												<div class="table-responsive"> -->
													<form id="frm">                            
														<div class="row">
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Nama Paket</label>
																	<input class="form-control" type="text" v-model="paket.nama_paket">
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Tipe</label>
																	<v-select
																	:options="lsttipe"
																	:reduce="lsttipe => lsttipe.id" 
																	label="text"
																	v-model="paket.tipe_paket"
																	/>	
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Harga Aawal</label>
																	<input class="form-control" type="text" v-model="paket.harga_awal">
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Diskon Harga (%)</label>
																	<input class="form-control" type="number" v-model="paket.diskon" max="100">
																</div>
															</div>
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Masa Berlaku (bulan)</label>
																	<input class="form-control" type="text" v-model="paket.masa_berlaku">
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Diskon Referral</label>                                      
																	<input class="form-control" type="text" v-model="paket.diskon_referral">
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Komisi Referral</label>
																	<input class="form-control" type="text" v-model="paket.komisi_referral">
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>URL Gambar</label>
																	<input class="form-control" type="text" v-model="paket.url_gambar">
																</div>
															</div>
															
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status</label>
																	<v-select
																	:options="lststspublish"
																	:reduce="lststspublish => lststspublish.id" 
																	label="text"
																	v-model="paket.fg_publish"
																	/>
																	
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Pendaftaran</label>
																	<v-select
																	:options="lststspendaftaran"
																	:reduce="lststspendaftaran => lststspendaftaran.id" 
																	label="text"
																	v-model="paket.fg_pendaftaran"
																	/>
																	
																</div>
															</div>

															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Status Favorit</label>
																	<v-select
																	:options="lststsfav"
																	:reduce="lststsfav => lststsfav.id" 
																	label="text"
																	v-model="paket.fg_favorit"
																	/>
																	
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Link Telegram</label>
																	<input class="form-control" type="text" v-model="paket.url_telegram">
																</div>
															</div>
															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Kuota</label>
																	<input class="form-control" type="text" v-model="paket.slot">
																</div>
															</div>

															
															<div class="col-md-6 col-sm-12">
																<div class="form-group card-label">
																	<label>Deskripsi Paket</label>
																	<textarea id="review_desc" row="8" class="form-control" v-model="paket.deskripsi"></textarea>
																</div>
															</div>												
															
															<div class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">		
																		
																	<h3>BENEFIT PAKET</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addBenefit()">Tambah Benefit</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>No</th>
																				<th>Benefit</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstbenefit" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td><input class="form-control" type="text" v-model="ref.nama_benefit"></td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteBenefit(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>
															
															<div v-if="paket.tipe_paket=='2'" class="col-md-12 col-sm-12">
																<hr>
																<div class="table-responsive">	
																	<h3>JADWAL BIMBEL</h3>																
																	<div class="col-auto text-right float-right ml-auto">
																		<a href="#" class="btn btn-primary btn-sm" @click.prevent="addJadwal()">Tambah Jadwal</a>
																	</div>
																	<table id="tbl" class="table table-hover table-center mb-0">
																		<thead>
																			<tr>
																				<th>Pertemua Ke</th>
																				<th>Judul</th>
																				<th>Jadwal</th>
																				<th>Link Pertemuan</th>
																				<th>Link Rekaman</th>
																				<th>Aksi</th>
																			</tr>     
																		</thead>
																		<tbody>
																			<tr v-for="(ref, index) in lstjadwal" :key="ref">
																				<td class="text-center">{{ index + 1 }}</td>
																				<td><input class="form-control" type="text" v-model="ref.judul_pertemuan"></td>										
																				<td><input class="form-control" type="datetime-local"  v-model="ref.jadwal_pertemuan"></td>										
																				<td><input class="form-control" type="text" v-model="ref.link_pertemuan"></td>										
																				<td><input class="form-control" type="text" v-model="ref.link_rekaman"></td>										
																				<td class="text-center">
																					<v-btn color="btn btn-sm bg-danger-light" depressed small @click="deleteJadwal(index)">
																						<i class="fas fa-times"></i> Delete
																					</v-btn>
																				</td>
																			</tr>
																			
																		</tbody>  	
																	</table>																	
																</div>
															</div>
															
														</div>
														
														<!-- <div class="form-group">
															<label>Judul <span class="text-danger">*</span></label>
															<input class="form-control" type="text" v-model="subdtlmateri.nama_judul">
														</div> -->
														<br>
													</form>
												<!-- </div>
											</div> -->
										<!-- </div> -->
									</div>

									
									<div id="attachtryout" class="tab-pane fade">
										<div class="table-responsive">
											
											<h3>Daftar Latihan</h3>		
											<table id="tblToPaket" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan / Kategori / Subject</th>
														<th class="text-left">Paket Soal</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in paketlsttryout" :key="ref.id_to">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
														<td>{{ ref.nama_to }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="deattachTo(index, ref)">
																<i class="fas fa-eye"></i> DeAttach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
											<br><hr><br>
											
											<h3>Draft Latihan</h3>		
											<table id="tblToDraft" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan / Kategori / Subject</th>
														<th class="text-left">Paket Soal</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in lsttryout" :key="ref.id_to">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }} / {{ ref.nama_materi }} / {{ ref.nama_sub_materi }}</td>
														<td>{{ ref.nama_to }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="attachTo(index, ref)">
																<i class="fas fa-eye"></i> Attach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
										</div>
									</div>

									<div id="attachkategori" class="tab-pane fade">
										<div class="table-responsive">
											
											<h3>Daftar Kategori</h3>		
											<table id="tblKategoriPaket" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan</th>
														<th class="text-left">Materi</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in paketlstmateri" :key="ref.id_materi">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }}</td>
														<td>{{ ref.nama_materi }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="deattachKategori(index, ref)">
																<i class="fas fa-eye"></i> DeAttach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
											<br><hr><br>
											
											<h3>Draft Kategori</h3>		
											<table id="tblKategoriDraft" class="table table-hover table-center mb-0">
												<thead>
													<tr>
														<th class="text-left">#</th>
														<th class="text-left">Tingkatan</th>
														<th class="text-left">Materi</th>
														<th class="text-left">Action</th>
													</tr>
												</thead>
							
												<tbody>
													<tr v-for="(ref, index) in lstmateri" :key="ref.id_materi">
														<td>{{ index + 1 }}</td>
														<td>{{ ref.nama_tingkatan }}</td>
														<td>{{ ref.nama_materi }}</td>
														<td>
															<v-btn class="btn btn-sm bg-success-light" depressed small @click="attachKategori(index, ref)">
																<i class="fas fa-eye"></i> Attach
															</v-btn>
														</td>
													</tr>
												</tbody>                                            
											</table>
										</div>
									</div>

								</div>	
							<!-- </div>
						</div> -->

					</div>
					<div class="modal-footer">
						<div class="submit-section text-center">
							<button class="btn btn-primary submit-btn" @click.prevent="save">Simpan Paket</button>
						</div>
					</div>
				</div>
			</div>
		</div>

		
        <div id="delMdl" class="modal custom-modal fade" role="dialog">
            <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">Hapus Paket</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <form>
                            <div class="form-group">
                                <label>Apakah anda yakin akan menghapus paket <b>{{ paket.nama_paket }}</b></label>
                            </div>
                            <div class="submit-section">
                                <button class="btn btn-primary submit-btn" @click.prevent="hapus">Yakin</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>


	</div>
		<!-- /Main Wrapper -->
</template>


<script>
// import instructors from '../../../assets/json/instructorslist'
// const images = require.context('@/assets/img/clients', false, /\.png$|\.jpg$/)
// import schoolvisits from '../../../assets/json/instructor/dashboard/schoolvisits'
// import coursetakenrecords from '../../../assets/json/instructor/dashboard/coursetakenrecords'
// import billing from '../../../assets/json/instructor/dashboard/billing'

import Sidebar from '../Sidebar'
import axios from 'axios';
import 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import "datatables.net-dt/js/dataTables.dataTables";
import "datatables.net-dt/css/jquery.dataTables.min.css";
import $ from 'jquery'

export default {
    components: {
        Sidebar
    },
	name: 'kelas-saya',
    // vuetify: new Vuetify(),
    data() {
        return {
            lstpaket: [],
            paket:{
                id_paket: '',
                nama_paket: '',
                tipe_paket: '',
                harga_awal: '',
                diskon: '',
				harga_aktif: '',
                masa_berlaku: '',
				jml_to: '',
                diskon_referral: '',
                komisi_referral: '',
                url_gambar: '',
                fg_publish: '',
                fg_pendaftaran: '',
                fg_favorit: '',
                url_telegram: '',
                slot: '',
				deskripsi: ''
            },
            lsttipe: [
                {id: '1', text: 'MANDIRI'},
                {id: '2', text: 'BIMBEL'}
            ],
            lststspublish: [
                {id: '1', text: 'DRAFT'},
                {id: '2', text: 'PUBLISH'}
            ],
            lststspendaftaran: [
                {id: '1', text: 'DITUTUP'},
                {id: '2', text: 'DIBUKA'}
            ],
            lststsfav: [
                {id: '1', text: 'TIDAK'},
                {id: '2', text: 'YA'}
            ],
			lstbenefit: [],
			lstjadwal: [],
			lsttryout: [],
			paketlsttryout: [],
			lstmateri: [],
			paketlstmateri: [],
            //     {id_paket_benefit: '1', nama_benefit: 'Benefit 1'},
			// ]
            // lstmateri: [],
            // materi:{
            //     id_materi: '',
            //     id_tingkatan: '',
            //     nama_materi: '',
            // },
            // lstsubmateri: [],
            // submateri: {
            //     id_sub_materi: '',
            //     id_materi: '',
            //     nama_sub_materi: '',
            // },
        }
    },
    created: function () {
        // this.refreshAll();
        
        this.getAll();
        // this.getAllMateri();
        // this.getAllSub();
        // this.initDt("tblMateri");
        // this.initDt("tblSub");

    },  

    methods: {
        initDt(tbId) {
           setTimeout(() => {
                $('#'+tbId).DataTable({
                    "pagingType": "full_numbers",
                    "bLengthChange": false,
                    pageLength : 10,
                    responsive: true,
                    destroy: true,
                    retrieve: true,
                    autoFill: true,
                    colReorder: true,
                });
               }, 300)
               
                
        },
      
        clearTbl(tbId){
            // $('#'+tbId).DataTable();
            var table = $('#'+tbId).DataTable();
            table.destroy();
        },

        reloadTbl(tbId){

            // dT.destroy();
            $('#'+tbId).DataTable();
            $('#'+tbId).destroy();
            this.initDt('#'+tbId);
            // $('#'+tbId).ajax.reload();
        },

        refreshAll(){
            this.getAll();
            this.getAllMateri();
            this.getAllSub();
            
            // this.reloadTbl("tbl");
            // this.reloadTbl("tblMateri");
            // this.reloadTbl("tblSub");
        },

        // Get Product
        getAll: function () {
            axios.get('api/paketinst/'+localStorage.getItem('idUser'))
                .then(res => {
                    // console.log(res.data);
                    this.clearTbl("tbl");
                    this.lstpaket = res.data.data;
					console.log(res.data.data);
                    this.initDt("tbl");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
        // Create New product
        save: function () {
            axios.post('api/paketinst', {
                    created_by: localStorage.getItem('idUser'),
                    id_paket: this.paket.id_paket,
                    nama_paket: this.paket.nama_paket,
                    tipe_paket: this.paket.tipe_paket,
                    harga_awal: this.paket.harga_awal,
                    diskon: this.paket.diskon,
                    masa_berlaku: this.paket.masa_berlaku,
                    diskon_referral: this.paket.diskon_referral,
                    komisi_referral: this.paket.komisi_referral,
                    url_gambar: this.paket.url_gambar,
                    fg_publish: this.paket.fg_publish,
                    fg_pendaftaran: this.paket.fg_pendaftaran,
                    fg_favorit: this.paket.fg_favorit,
                    url_telegram: this.paket.url_telegram,
                    slot: this.paket.slot,
                    deskripsi: this.paket.deskripsi,
					lstbenefit: this.lstbenefit,
					lstjadwal: this.lstjadwal,
					lsttryout: this.paketlsttryout,
					lstmateri: this.paketlstmateri,
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#addMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        addBenefit: function(){
			this.lstbenefit.push({ id_paket:this.paket.id_paket, nama_paket: '' });
		},

		deleteBenefit: function(index){
			this.lstbenefit.splice(index, 1);
		},

        addJadwal: function(){
			this.lstjadwal.push({ id_paket:this.paket.id_paket, nama_jadwal: '' });
		},

		deleteJadwal: function(index){
			this.lstjadwal.splice(index, 1);
		},
		
        attachTo: function(index, ref){			
			this.clearTbl("tblToPaket");
			this.clearTbl("tblToDraft");
			this.paketlsttryout.push(ref);
			this.lsttryout.splice(index, 1);
			this.initDt("tblToPaket");
			this.initDt("tblToDraft");
		},

		deattachTo: function(index, ref){					
			this.clearTbl("tblToPaket");
			this.clearTbl("tblToDraft");
			this.paketlsttryout.splice(index, 1);
			this.lsttryout.push(ref);
			this.initDt("tblToPaket");
			this.initDt("tblToDraft");
		},

        attachKategori: function(index, ref){			
			this.clearTbl("tblKategoriPaket");
			this.clearTbl("tbl KategoriDraft");
			this.paketlstmateri.push(ref);
			this.lstmateri.splice(index, 1);
			this.initDt("tbl KategoriPaket");
			this.initDt("tbl KategoriDraft");
		},

		deattachKategori: function(index, ref){					
			this.clearTbl("tbl KategoriPaket");
			this.clearTbl("tbl KategoriDraft");
			this.paketlstmateri.splice(index, 1);
			this.lstmateri.push(ref);
			this.initDt("tbl KategoriPaket");
			this.initDt("tbl KategoriDraft");
		},

        resetVar: function(ref){
            if(ref){
				this.paket.id_paket = ref.id_paket;
				this.paket.nama_paket = ref.nama_paket;
				this.paket.tipe_paket = ref.tipe_paket;
				this.paket.harga_awal = ref.harga_awal;
				this.paket.diskon = ref.diskon;
				this.paket.masa_berlaku = ref.masa_berlaku;
				this.paket.diskon_referral = ref.diskon_referral;
				this.paket.komisi_referral = ref.komisi_referral;
				this.paket.url_gambar = ref.url_gambar;
				this.paket.fg_publish = ref.fg_publish;
				this.paket.fg_pendaftaran = ref.fg_pendaftaran;
				this.paket.fg_favorit = ref.fg_favorit;
				this.paket.url_telegram = ref.url_telegram;
				this.paket.slot = ref.slot;
				this.paket.deskripsi = ref.deskripsi;
				if(ref.list_benefit) this.lstbenefit = ref.list_benefit;
				else this.lstbenefit = [];
				if(ref.list_jadwal) this.lstjadwal = ref.list_jadwal;
				else this.lstjadwal = [];
			
                this.clearTbl("tblToPaket");
				if(ref.list_tryout) this.paketlsttryout = ref.list_tryout;
				else this.paketlsttryout = [];
                this.initDt("tblToPaket");
				
                this.clearTbl("tblKategoriPaket");
				if(ref.list_materi) this.paketlstmateri = ref.list_materi;
				else this.paketlstmateri = [];
                this.initDt("tblKategoriPaket");

            } else {
				this.paket.id_paket = '';
				this.paket.nama_paket = '';
				this.paket.tipe_paket = '';
				this.paket.harga_awal = '';
				this.paket.diskon = '';
				this.paket.masa_berlaku = '';
				this.paket.diskon_referral = '';
				this.paket.komisi_referral = '';
				this.paket.url_gambar = '';
				this.paket.fg_publish = '';
				this.paket.fg_pendaftaran = '';
				this.paket.fg_favorit = '';
				this.paket.url_telegram = '';
				this.paket.slot = '';
				this.paket.deskripsi = '';
				this.lstbenefit = [];
				this.lstjadwal = [];
				this.paketlsttryout = [];
				this.paketlstmateri = [];
            }
        },

		getAdd: function () {
            this.resetVar(null);
			// this.getAllTryout();
			// this.getAllMateri();
            $("#addMdl").modal('show');
        },

        // Get Edit and Show data to Modal
        getEdit: function (ref) {
            this.resetVar(ref);
			this.getAllTryout(ref.id_paket);
			this.getAllMateri(ref.id_paket);
            $("#addMdl").modal('show');
        },
 
        // Get Delete and Show Confirm Modal
        getDelete: function (ref) {
            this.resetVar(ref);
            $("#delMdl").modal('show');
        },
 
        // Delete Product
        hapus: function () {
            axios.post('api/paketinstdel', {
                    created_by: localStorage.getItem('idUser'),
                    id_paket: this.paket.id_paket,
                })
                .then(res => {
                    // handle success
                    this.getAll();
                    this.resetVar();
                    $("#delMdl").modal('hide');
                    // this.refreshAll();
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

		//--------------------------
		// GET Tryout
		getAllTryout: function (id_paket) {
            axios.get('api/tryoutpaketinst/'+id_paket+'/'+localStorage.getItem('idUser'))
                .then(res => {
                    // console.log(res.data);
                    // this.clearTbl("tblToPaket");
                    this.clearTbl("tblToDraft");
                    this.lsttryout = res.data.data;
					// this.paketlsttryout = [];
                    // this.initDt("tblToPaket");
                    this.initDt("tblToDraft");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },

        //--------------------------
        // Get Materi
        getAllMateri: function (id_paket) {
            axios.get('api/materipaketinst/'+id_paket+'/'+localStorage.getItem('idUser'))
                .then(res => {                    
                    // this.clearTbl("tblKategoriPaket");
                    this.clearTbl("tblKategoriDraft");
                    this.lstmateri = res.data.data;
					// this.paketlstmateri = [];
                    // this.initDt("tblKategoriPaket");
                    this.initDt("tblKategoriDraft");
                })
                .catch(err => {
                    // handle error
                    console.log(err);
                })
        },
 
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Instructor/KelasSaya/index.vue